module.exports = __webpack_public_path__ + "img/ski_cos4.e616a533.png";